import { graphql } from "@opensea/graphql"
import { CollectionMetadataChipFragment } from "./CollectionMetadataChip.fragment"

export const CollectionMetadataChipsFragment = graphql(
  `
    fragment CollectionMetadataChips on Collection {
      isVerified
      isApproved
      ...CollectionMetadataChip
    }
  `,
  [CollectionMetadataChipFragment],
)
